// src/components/GroupList/GroupList.jsx
import React from "react";
import {
  FaHome,
  FaGraduationCap,
  FaBookOpen,
  FaBriefcase,
  FaEllipsisH,
} from "react-icons/fa";
import "./GroupList.css";

export default function GroupList({ groups }) {
  return (
    <div className="group-list">
      {groups.map((g, i) => (
        <div key={i} className="group-card">
          {/* ── Imagen en la parte superior de la card ── */}
          {g["Image URL"] && g["Image URL"] !== "-" && (
            <div className="group-card__img-wrapper">
              <img
                src={g["Image URL"]}
                alt={g["Institución"]}
                className="group-card__img"
              />
            </div>
          )}

          <div className="group__data">
            {/* Nombre de la institución / grupo */}
            <h2 className="group-title">{g["Institución"]}</h2>

            {/* Badge de categoría */}
            {/* <div className="group-category">Categoría: {g["Categoría"]}</div> */}

            {/* Acerca De */}
            {g["Acerca De"] && (
              <p className="group-about">
                <strong>Acerca de:</strong> {g["Acerca De"]}
              </p>
            )}

            {/* Enlaces */}
            <div className="group-links">
              {g["Casa/Cuartos"] && g["Casa/Cuartos"] !== "-" && (
                <a
                  href={g["Casa/Cuartos"]}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-cuarto"
                >
                  <FaHome /> Cuartos
                </a>
              )}
              {g["Becas"] && g["Becas"] !== "-" && (
                <a
                  href={g["Becas"]}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-beca"
                >
                  <FaGraduationCap /> Becas
                </a>
              )}
              {g["Books"] && g["Books"] !== "-" && (
                <a
                  href={g["Books"]}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-libro"
                >
                  <FaBookOpen /> Libros
                </a>
              )}
              {g["Trabajos Medio Tiempo"] &&
                g["Trabajos Medio Tiempo"] !== "-" && (
                  <a
                    href={g["Trabajos Medio Tiempo"]}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-trabajo"
                  >
                    <FaBriefcase /> Trabajos
                  </a>
                )}
              {g["Otros"] && g["Otros"] !== "-" && (
                <a
                  href={g["Otros"]}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-otro"
                >
                  <FaEllipsisH /> Otros
                </a>
              )}
            </div>
          </div>

          {/* Términos y Condiciones (T&C) */}
          {/* {g["T&C"] && g["T&C"] !== "-" && (
            <p className="group-tnc">
              <em>
                <strong>T&C:</strong> {g["T&C"]}
              </em>
            </p>
          )} */}
        </div>
      ))}
    </div>
  );
}
